module.exports = __webpack_public_path__ + "hbomaxar-static/media/LiquidTrip_SmallLoop_00050.6097a2f5.png";